import { render, staticRenderFns } from "./UiPopover.vue?vue&type=template&id=4555393e&scoped=true"
import script from "./UiPopover.vue?vue&type=script&lang=js"
export * from "./UiPopover.vue?vue&type=script&lang=js"
import style0 from "./UiPopover.vue?vue&type=style&index=0&id=4555393e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555393e",
  null
  
)

export default component.exports